export default "__VITE_ASSET__4693e7ef__"